
/**  查询公司账户  参数companyId*/
export const queryCompanyAccountInfo = '/admin/companyAccount/info'

/** 商家端顶部数据   **/
export const orderStatusCount = '/task/taskOrder/orderStatusCount'

/** 商品好评   **/
export const evaluation = '/task/taskOrder/evaluation'

/**  查询店铺列表  */
export const storeList = '/task/store/queryShopList'

/**  新增店铺  */
export const addStore = '/task/store/creatShop'

/**  编辑店铺  */
export const editStore = '/task/store/modifyShtoreInfo'

/**  关闭/开启店铺  */
export const operateStoreStatus = '/task/store/OperateStoreStatus'

/** 个人资料，基本资料获取   **/
export const queryAdminInfo = '/admin'

/** 个人资料，基本资料编辑   **/
export const editAdminInfo = '/admin/update'

/** 任务模板   **/
export const taskTemplateList = '/task/taskTemplate/list'

/** 任务模板   **/
export const removeTaskTemplate = '/task/taskTemplate/delTemplate'

/** 模板详情查询   **/
export const taskTemplateDetail = '/task/taskTemplate/taskTemplate'




// WEBPACK FOOTER //
// ./src/http/moudules/bs.js